// components/VersionBadge.tsx
'use client';

import { useEffect, useState } from 'react';

interface VersionInfo {
  version: string;
}

export default function VersionBadge() {
  const [info, setInfo] = useState<VersionInfo>({ version: '...' });

  useEffect(() => {
    fetch('/version.json')
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json() as Promise<VersionInfo>;
      })
      .then(setInfo)
      .catch(() => setInfo({ version: 'DEV' }));
  }, []);

  return (
    <span className="text-xs text-gray-400">
      Version: {info.version}
    </span>
  );
}